import { useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const FIRM = {
  ad: 'www.ladiora.com.tr',
  adres: 'Ankara / Çankaya',
};

const firmBlock = `<p><strong>${FIRM.ad}</strong><br/>Adres: ${FIRM.adres}</p>`;

const legalContent: Record<string, { title: string; content: string }> = {
  'kullanim-kosullari': {
    title: 'Kullanım Koşulları',
    content: `<h2>1. TARAFLAR</h2>
<p>İşbu Kullanım Koşulları ("Koşullar"), www.ladiora.com.tr internet sitesinin ("Site") kullanımına ilişkin şartları düzenler.</p>
<p><strong>Site sahibi:</strong><br/>${FIRM.ad}<br/>Adres: ${FIRM.adres}</p>
<p>Siteyi kullanan tüm gerçek ve tüzel kişiler ("Kullanıcı"), işbu Koşulları kabul etmiş sayılır.</p>

<h2>2. HİZMET TANIMI</h2>
<p>Ladiora, kadın giyim ürünlerinin satışına yönelik bir e-ticaret platformudur. Site üzerinden ürün inceleme, sipariş verme ve alışveriş işlemleri gerçekleştirilebilir.</p>

<h2>3. KULLANIM ŞARTLARI</h2>
<p>3.1 Kullanıcı, Siteyi yalnızca hukuka uygun amaçlarla kullanacağını kabul eder.<br/>3.2 Kullanıcı, Siteye zarar verecek herhangi bir işlem gerçekleştiremez.<br/>3.3 Kullanıcı, üçüncü kişilerin haklarını ihlal edemez.</p>

<h2>4. ÜYELİK</h2>
<p>4.1 Kullanıcı, doğru ve güncel bilgiler vermekle yükümlüdür.<br/>4.2 Kullanıcı, hesap bilgilerini gizli tutmakla sorumludur.<br/>4.3 Hesap üzerinden yapılan işlemler Kullanıcı'ya aittir.</p>

<h2>5. FİKRİ MÜLKİYET HAKLARI</h2>
<p>Site içeriğinde yer alan tüm metin, görsel, logo ve tasarımlar ${FIRM.ad} sitesine aittir. İzinsiz kullanılamaz.</p>

<h2>6. SORUMLULUK REDDİ</h2>
<p>6.1 Site kesintisiz veya hatasız çalışacağına dair garanti verilmez.<br/>6.2 Sistemsel hatalar, teknik sorunlar veya mücbir sebeplerden doğan zararlardan satıcı sorumlu değildir.</p>

<h2>7. LİNKLER</h2>
<p>Site üzerinden üçüncü taraf sitelere yönlendirme yapılabilir. Bu sitelerin içeriklerinden satıcı sorumlu değildir.</p>

<h2>8. KİŞİSEL VERİLER</h2>
<p>Kullanıcıların kişisel verileri KVKK kapsamında işlenir. Detaylar KVKK Aydınlatma Metni ve Çerez Politikası'nda yer almaktadır.</p>

<h2>9. DEĞİŞİKLİKLER</h2>
<p>Satıcı, işbu Koşullar üzerinde dilediği zaman değişiklik yapma hakkını saklı tutar.</p>

<h2>10. UYUŞMAZLIK</h2>
<p>İşbu Koşulların uygulanmasında Türkiye Cumhuriyeti mevzuatı geçerlidir. Uyuşmazlıklarda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.</p>

<h2>11. YÜRÜRLÜK</h2>
<p>Kullanıcı, Siteyi kullanarak bu Koşulları kabul etmiş sayılır.</p>`
  },
  'gizlilik-politikasi': {
    title: 'Gizlilik ve Çerez Politikası',
    content: `<p>İşbu politika, www.ladiora.com.tr internet sitesini kullanan ziyaretçiler için hazırlanmış olup, kişisel verilerin korunması ve çerez kullanımı süreçlerini açıklamaktadır.</p>
<p><strong>Veri Sorumlusu:</strong> ${FIRM.ad}</p>

<h2>1. Bilgilerin Korunması</h2>
<p>Ziyaretçiler tarafından sağlanan kişisel veriler, KVKK'ya uygun şekilde korunmakta ve gerekli teknik/idari önlemler alınmaktadır. Sitede kart ile ödeme alınmaz; siparişler WhatsApp üzerinden tamamlanır ve ödemeler havale/EFT ile gerçekleştirilir. Banka hesap bilgileri güvenlik nedeniyle sitede yayınlanmaz.</p>

<h2>2. Kişisel Verilerin İşlenmesi</h2>
<p>Kişisel veriler; sipariş süreçlerinin yürütülmesi, teslimat ve faturalandırma, müşteri destek hizmetleri, yasal yükümlülüklerin yerine getirilmesi amaçlarıyla işlenir.</p>

<h2>3. Çerez Kullanımı</h2>
<p>Sitemizde zorunlu çerezler, analitik çerezler ve pazarlama çerezleri kullanılmaktadır. Çerezler; site performansını artırmak, kullanıcı deneyimini geliştirmek, reklam ve analiz süreçlerini yürütmek amacıyla kullanılmaktadır.</p>

<h2>4. Çerez Yönetimi</h2>
<p>Kullanıcılar tarayıcı ayarları üzerinden çerezleri silebilir veya engelleyebilir.</p>

<h2>5. Veri Aktarımı</h2>
<p>Veriler; kargo firmalarına ve yasal kurumlara aktarılabilir. Sipariş iletişimi WhatsApp üzerinden yürütülebilir.</p>

<h2>6. Haklarınız</h2>
<p>KVKK kapsamında bilgi talep etme, düzeltme, silme ve itiraz haklarına sahipsiniz.</p>

<h2>7. İletişim</h2>
${firmBlock}`
  },
  'kvkk': {
    title: 'KVKK Aydınlatma Metni',
    content: `<p>Kişisel verilerinizin işlenmesi ile ilgili uygulamalarımız ve 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") kapsamında "Veri Sorumlusu" sıfatıyla ${FIRM.ad} ("Ladiora") olarak işlediğimiz kişisel verilerinize ilişkin sizleri bilgilendirmek isteriz.</p>

<h2>1. Kişisel Verilerinizin Toplanma Yöntemi ve Amaçları</h2>
<h3>1.1 Site Kullanımı ve E-Ticaret Süreçleri</h3>
<p><strong>Amaçlar:</strong> Sipariş oluşturma, ödeme ve teslimat süreçlerinin yürütülmesi, ürünlerin kargolanması, sipariş ve iade süreçlerinin yönetilmesi, fatura düzenlenmesi, müşteri kayıtlarının tutulması.</p>
<p><strong>İşlenen Veriler:</strong> Ad, soyad, e-posta, telefon, adres, sipariş detayları, sepet bilgisi, iade bilgileri, IP adresi, log kayıtları.</p>

<h3>1.2 Üyelik İşlemleri</h3>
<p><strong>Amaçlar:</strong> Üyelik oluşturma ve yönetme, kullanıcı hesabı ile giriş yapılması, sipariş geçmişinin görüntülenmesi.</p>

<h3>1.3 Ödeme ve Finans Süreçleri</h3>
<p><strong>Amaçlar:</strong> WhatsApp üzerinden sipariş ve havale/EFT ödemelerinin takibi, iade süreçlerinin yürütülmesi.</p>

<h3>1.4 Teknik ve Güvenlik Süreçleri</h3>
<p><strong>Amaçlar:</strong> Sistem güvenliğinin sağlanması, hataların tespit edilmesi, dolandırıcılık ve kötüye kullanımın önlenmesi.</p>

<h3>1.5 Ticari İletişim Süreçleri</h3>
<p><strong>Amaçlar:</strong> Kampanya ve bilgilendirme gönderimi, pazarlama faaliyetleri. <strong>Hukuki Sebep:</strong> Açık rıza.</p>

<h2>2. Kişisel Verilerin Aktarımı</h2>
<p>Kişisel verileriniz; kargo firmalarına (teslimat için) ve yetkili kamu kurumlarına aktarılabilir. Sipariş iletişimi WhatsApp üzerinden yürütülebilir.</p>

<h2>3. Haklarınız</h2>
<p>KVKK'nın 11. maddesi kapsamında: Verilerinizin işlenip işlenmediğini öğrenme, düzeltilmesini talep etme, silinmesini talep etme, işlemeye itiraz etme haklarına sahipsiniz.</p>

<h2>4. Başvuru</h2>
${firmBlock}`
  },
  'mesafeli-satis-sozlesmesi': {
    title: 'Mesafeli Satış Sözleşmesi',
    content: `<h2>1. TARAFLAR</h2>
<p><strong>Satıcı:</strong><br/>${FIRM.ad}<br/>Adres: ${FIRM.adres}</p>
<p><strong>Alıcı:</strong> www.ladiora.com.tr üzerinden alışveriş yapan gerçek veya tüzel kişi.</p>

<h2>2. KONU</h2>
<p>İşbu sözleşme, Alıcı'nın www.ladiora.com.tr üzerinden elektronik ortamda sipariş verdiği ürünün satışı ve teslimine ilişkin olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamında tarafların hak ve yükümlülüklerini düzenler.</p>

<h2>3. SİPARİŞ VE ÖDEME</h2>
<p>3.1 Ürün fiyatları ve özellikleri site üzerinde belirtilmiştir.<br/>3.2 Ödemeler WhatsApp üzerinden iletilen sipariş doğrultusunda havale/EFT ile yapılır. Kart ile online ödeme alınmaz. Banka hesap bilgileri güvenlik nedeniyle sitede gösterilmez; sipariş sırasında WhatsApp üzerinden paylaşılır.<br/>3.3 Satıcı, siparişin güvenliği için gerekli gördüğü durumlarda siparişi iptal etme hakkına sahiptir.</p>

<h2>4. TESLİMAT</h2>
<p>4.1 Ürünler, Alıcı'nın belirttiği adrese kargo ile teslim edilir.<br/>4.2 Teslim süresi yasal olarak 30 günü aşamaz.<br/>4.3 Kargo sırasında oluşabilecek hasarlarda Alıcı'nın teslim sırasında kontrol etmesi gerekir.</p>

<h2>5. CAYMA HAKTI</h2>
<p>5.1 Alıcı, ürünü teslim aldığı tarihten itibaren 7 gün içinde cayma hakkını kullanabilir.<br/>5.2 Cayma hakkı için WhatsApp üzerinden yazılı bildirim yapılmalıdır.<br/>5.3 Cayma hakkı kapsamında ürün kullanılmamış olmalıdır.</p>

<h2>6. CAYMA HAKKININ GEÇERSİZ OLDUĞU DURUMLAR</h2>
<p>Kişiye özel üretilen ürünler, hijyen nedeniyle iadesi uygun olmayan ürünler, kullanılmış ürünler.</p>

<h2>7. İADE VE GERİ ÖDEME</h2>
<p>7.1 İade edilen ürün Satıcı'ya ulaştıktan sonra 14 gün içinde ödeme iade edilir.<br/>7.2 İade, Alıcı'nın bildirdiği banka hesabına havale/EFT ile yapılır.</p>

<h2>8. SORUMLULUK</h2>
<p>8.1 Satıcı, sistemsel hatalar veya mücbir sebeplerden kaynaklanan gecikmelerden sorumlu değildir.<br/>8.2 Alıcı, siteyi hukuka uygun kullanacağını kabul eder.</p>

<h2>9. KİŞİSEL VERİLER</h2>
<p>Alıcı'nın kişisel verileri KVKK kapsamında işlenir ve korunur.</p>

<h2>10. UYUŞMAZLIK</h2>
<p>Uyuşmazlıklarda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.</p>

<h2>11. YÜRÜRLÜK</h2>
<p>Alıcı, siparişi tamamladığında bu sözleşmeyi kabul etmiş sayılır.</p>`
  },
  'cerez-politikasi': {
    title: 'Çerez Politikası',
    content: `<p>İşbu politika, www.ladiora.com.tr internet sitesini kullanan ziyaretçiler için hazırlanmış olup, çerez kullanımı süreçlerini açıklamaktadır.</p>
<p><strong>Veri Sorumlusu:</strong> ${FIRM.ad}</p>

<h2>Çerez Kullanımı</h2>
<p>Sitemizde zorunlu çerezler, analitik çerezler ve pazarlama çerezleri kullanılmaktadır.</p>
<p>Çerezler; site performansını artırmak, kullanıcı deneyimini geliştirmek, reklam ve analiz süreçlerini yürütmek amacıyla kullanılmaktadır.</p>

<h2>Çerez Yönetimi</h2>
<p>Kullanıcılar tarayıcı ayarları üzerinden çerezleri silebilir veya engelleyebilir.</p>

<h2>İletişim</h2>
${firmBlock}`
  }
};

export function LegalPage() {
  const { slug } = useParams();
  const page = legalContent[slug || ''];

  if (!page) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center"><p className="text-gray-600 text-xl">Sayfa bulunamadı</p></main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">{page.title}</h1>
          <div className="bg-white rounded-xl shadow-sm p-6 md:p-10 prose prose-gray max-w-none [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-8 [&_h2]:mb-4 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-gray-800 [&_h3]:mt-6 [&_h3]:mb-3 [&_p]:text-gray-700 [&_p]:leading-relaxed [&_p]:mb-4 [&_hr]:my-8 [&_hr]:border-gray-200"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
